// Zentraler Zugriff auf die 10 Gast-Slots eines Kunden (Spaltentripel plus eigener Einladungscode und Anwesenheit).
// Gegenstück zu CustomerGuests.cs im Backend.

export const MAX_GUEST_SLOTS = 10

export function guestFieldNames(slot) {
  if (slot === 1) {
    return { givenName: 'firstGuestGivenName', familyName: 'firstGuestFamilyName', email: 'firstGuestEmail', invitationCode: 'guestInvitationCode1', wasAttending: 'guestWasAttending1' }
  }

  if (slot === 2) {
    return { givenName: 'secondGuestGivenName', familyName: 'secondGuestFamilyName', email: 'secondGuestEmail', invitationCode: 'guestInvitationCode2', wasAttending: 'guestWasAttending2' }
  }

  return { givenName: `guestGivenName${slot}`, familyName: `guestFamilyName${slot}`, email: `guestEmail${slot}`, invitationCode: `guestInvitationCode${slot}`, wasAttending: `guestWasAttending${slot}` }
}

function isFilled(value) {
  return value != null && String(value).trim().length !== 0
}

/** Alle Slots 1–10 eines Kunden, auch leere. */
export function guestSlots(customer) {
  if (customer == null) {
    return []
  }

  const slots = []

  for (let slot = 1; slot <= MAX_GUEST_SLOTS; slot++) {
    const fields = guestFieldNames(slot)
    const givenName = customer[fields.givenName]
    const familyName = customer[fields.familyName]
    const email = customer[fields.email]

    slots.push({
      slot,
      fields,
      givenName,
      familyName,
      email,
      invitationCode: customer[fields.invitationCode] || null,
      wasAttending: customer[fields.wasAttending] === true,
      hasData: isFilled(givenName) || isFilled(familyName) || isFilled(email)
    })
  }

  return slots
}

/** Nur belegte Slots. */
export function guests(customer) {
  return guestSlots(customer).filter(g => g.hasData)
}

export function personName(givenName, familyName) {
  return `${givenName || ''} ${familyName || ''}`.trim()
}

/**
 * Alle Personen eines Kontos: Slot 0 = Kunde (Ansprechpartner), 1–10 = Gäste.
 * Jede Person hat ihren eigenen Einladungscode und ihr eigenes Anwesenheitskennzeichen.
 */
export function participants(customer) {
  if (customer == null) {
    return []
  }

  const list = [{
    slot: 0,
    isGuest: false,
    givenName: customer.givenName,
    familyName: customer.familyName,
    name: personName(customer.givenName, customer.familyName),
    invitationCode: customer.invitationCode || null,
    wasAttending: customer.wasAttending === true
  }]

  for (const guest of guests(customer)) {
    list.push({
      slot: guest.slot,
      isGuest: true,
      givenName: guest.givenName,
      familyName: guest.familyName,
      name: personName(guest.givenName, guest.familyName),
      invitationCode: guest.invitationCode,
      wasAttending: guest.wasAttending
    })
  }

  return list
}

/** Kunde zählt als „vor Ort“, sobald er selbst oder einer seiner Gäste bestätigt ist. */
export function anyoneAttending(customer) {
  return participants(customer).some(p => p.wasAttending)
}

/** Findet die Person zu einem Kunden- oder Gastcode über alle Kunden; null, wenn unbekannt. */
export function findParticipantByInvitationCode(customers, invitationCode) {
  if (customers == null || !isFilled(invitationCode)) {
    return null
  }

  const code = invitationCode.trim().toUpperCase()

  for (const customer of customers) {
    const participant = participants(customer).find(p => p.invitationCode != null && p.invitationCode.toUpperCase() === code)

    if (participant != null) {
      return { customer, participant }
    }
  }

  return null
}
